import React from "react";
import {formatName, formatNames} from "../../utils";
import order from './order';
import PipelineDetails, { hotlist } from "../PipelineDetails/PipelineDetails";
import {proposal, active, negotiation, underContract, closed, closedYTD, closedHistorical} from "../PipelineDetails/PipelineDetails";
import { GET_STRIVE_AGENT_PIPELINE_DETAILS,GET_TEAM, GET_TEAM_MEMBER,GET_STRIVE_AGENT_HOTLIST_PROPERTIES} from "../Graphql/Queries/AgentPipelineQuery";
import { mapToOldResponse } from "../ResponseConversion/GetOldResponse";
import { fetchData } from "../Service/graphQlService";
import { GET_CONTACT_TEAM_BY_ARCIMEDES_ID } from "../Graphql/ContactsQueries/contactsQuery";
import moment from "moment";

export default class AgentPipelineDetails extends PipelineDetails {
    constructor(props) {
        super(props);

        this.state = {
            tables: {
                [hotlist]: {
                    name: 'Hot List',
                    data: [],
                    total: {},
                },
                [proposal]: {
                    name: 'Proposals',
                    data: [],
                    total: {},
                },
                [active]: {
                    name: 'Active Listings',
                    data: [],
                    total: {},
                },
                [negotiation]: {
                    name: 'Neg/Under Contract',
                    data: [],
                    total: {},
                },
                [closedYTD]: {
                    name: 'Closed - YTD',
                    data: [],
                    total: {},
                },
                [closedHistorical]: {
                    name: 'Closed - Historical',
                    data: [],
                    total: {},
                },
            },
            agentName: '',
            loading: true,
            componentName: 'agentPipelineDetails',
            loader:true
        };
    }

    static createOptions({id, status1, status2, isYtd = 0, orderBy}) {
        return {
            param: {
                AGENT_ID: id,
                STATUS_1: status1,
                STATUS_2: status2 ? status2 : 'NOMATCH',
                IS_YTD: isYtd
            },
            order: order(orderBy),
        };
    }

    static createOptionsWithOnlyEmailId({emailId}) {
        return {
            param: {
                email_id : emailId
            },        
        };
    }
    buildTables(res) {
        const tables = {...this.state.tables};
        const id = this.props.location && this.props.location.state && this.props.location.state.id ? this.props.location.state.id :
            (this.props.id ? this.props.id : this.props.params.id);
        tables[hotlist] = AgentPipelineDetails.buildTable(hotlist, tables[hotlist], res[6].data[0].data, "", id);
        tables[proposal] = AgentPipelineDetails.buildTable(proposal, tables[proposal], res[0].data[0].GETSTRIVEAGENTPIPELINEDETAILS, "", id);
        tables[active] = AgentPipelineDetails.buildTable(active, tables[active], res[1].data[0].GETSTRIVEAGENTPIPELINEDETAILS), "", id;
        tables[negotiation] = AgentPipelineDetails.buildTable(negotiation, tables[negotiation], res[2].data[0].GETSTRIVEAGENTPIPELINEDETAILS, "", id);
        tables[closedYTD] = AgentPipelineDetails.buildTable(closedYTD, tables[closedYTD], res[3].data[0].GETSTRIVEAGENTPIPELINEDETAILS, "", id);
        tables[closedHistorical] = AgentPipelineDetails.buildTable(closedHistorical, tables[closedHistorical], res[4].data[0].GETSTRIVEAGENTPIPELINEDETAILS, "", id);
        this.setState({tables});
    }
    convertedObj(obj){
       return Object.entries(obj).reduce((acc, [key, value]) => {
            acc[key.toLowerCase()] = value;
            return acc;
        }, {});
    }

    fetch(id,emailId,contactId) {
      
        const proposalOptions = AgentPipelineDetails.createOptions({
            id: id,
            status1: proposal,
            orderBy: 'DATE_CREATED.asc'
        });
        const activeOptions = AgentPipelineDetails.createOptions({
            id: id,
            status1: active,
            orderBy: 'LISTING_DATE.asc'
        });
        const negotiationOptions = AgentPipelineDetails.createOptions({
            id: id,
            status1: negotiation,
            status2: underContract,
            orderBy: 'STATUS.asc'
        });
        const closedYtdOptions = AgentPipelineDetails.createOptions({
            id: id,
            status1: closed,
            isYtd: 1,
            orderBy: 'CLOSE_OF_ESCROW.asc'
        });
        const closedHistoricalOptions = AgentPipelineDetails.createOptions({
            id: id,
            status1: closed,
            orderBy: 'CLOSE_OF_ESCROW.desc'
        });
        
        const token = localStorage.getItem('authToken');
        const requests = [           

            fetchData( GET_STRIVE_AGENT_PIPELINE_DETAILS,{params:proposalOptions.param}),
            fetchData( GET_STRIVE_AGENT_PIPELINE_DETAILS,{params:activeOptions.param}),
            fetchData( GET_STRIVE_AGENT_PIPELINE_DETAILS,{params:negotiationOptions.param}),
            fetchData( GET_STRIVE_AGENT_PIPELINE_DETAILS,{params:closedYtdOptions.param}),
            fetchData( GET_STRIVE_AGENT_PIPELINE_DETAILS,{params:closedHistoricalOptions.param}),
         
        ];
        let agentPhone = '';
        let agentName = this.props.location && this.props.location.state ? this.props.location.state.name : this.props.name;
        //requests.push(fetchData(GET_CONTACT_TEAM_BY_ID, {contactid:Number(id)}));
       // if (!agentName) {
            const options = {
                column: [
                    'FIRST_NAME',
                    'LAST_NAME',
                ],
                filter: [{
                    'text': id,
                    'code': 'ARCIMEDES_ROW_ID',
                    'type': 'exact',
                }],
            };
            // requests.push(getData({tableCode: TEAM, options}));

            // requests.push(fetchData(GET_CONTACT_TEAM_BY_ID, {contactid:Number(id)}));
            requests.push(fetchData( GET_CONTACT_TEAM_BY_ARCIMEDES_ID,{arcimedes_row_id: Number(id)}))
       // }

        Promise.all(requests).then(async(res) => {
            if(res.length > 0){
                this.setState({loader : false})
            } 
            var responses = mapToOldResponse(res).responses;
            
            if (res && responses[0] && responses[0].success && Array.isArray(responses[0].data[0].GETSTRIVEAGENTPIPELINEDETAILS) &&
                responses[1] && responses[1].success && Array.isArray(responses[1].data[0].GETSTRIVEAGENTPIPELINEDETAILS) &&
                responses[2] && responses[2].success && Array.isArray(responses[2].data[0].GETSTRIVEAGENTPIPELINEDETAILS) &&
                responses[3] && responses[3].success && Array.isArray(responses[3].data[0].GETSTRIVEAGENTPIPELINEDETAILS) &&
                responses[4] && responses[4].success && Array.isArray(responses[4].data[0].GETSTRIVEAGENTPIPELINEDETAILS) &&
                (!res[5] || res[5])) 
                {
                if (res[5]) { // need to verify the new response and if required modifications need to do
                    // agentName = formatNames(res[5].data.getTeamMember);'
                    if(!agentName){
                    agentName = formatNames(res[5].data.getContactTeamByArcId.contact ? res[5].data.getContactTeamByArcId.contact : {});
                    }
                    agentPhone = res[5].data.getContactTeamByArcId.contact ? res[5].data.getContactTeamByArcId.contact.on_phones : null;
                    const hotlistRes = await fetchData(GET_STRIVE_AGENT_HOTLIST_PROPERTIES, { email_id:res[5].data.getContactTeamByArcId.contact && res[5].data.getContactTeamByArcId.contact.email || ""});
                    res.push(hotlistRes);
                    if (agentPhone) {
                        
                        this.calculateDateRange(agentPhone);
                    }
                     responses.push({
                        success: true,
                        data: [hotlistRes.data.getHotListProperties || {}],
                    }); 

                    
                }
                
                this.setState({agentName}, () => this.buildTables(responses));
            }
            this.setState({loading: false});
        });
    }
     

    calculateDateRange(date) {
        const givenDate = moment(date, 'MM-DD-YYYY');
        const today = moment();
        const diffInYrs = today.diff(givenDate, 'years', true);
        if (diffInYrs <= 1.5) {
            this.state.tables[proposal].goalValue = 4
            this.state.tables[active].goalValue =3
            this.state.tables[negotiation].goalValue = 2
            this.state.tables[closedYTD].goalValue = 4
        } else if (diffInYrs > 1.5 && diffInYrs <= 3) {
            this.state.tables[proposal].goalValue = 4
            this.state.tables[active].goalValue =6
            this.state.tables[negotiation].goalValue = 4
            this.state.tables[closedYTD].goalValue = 8
        } else if (diffInYrs > 3) {
            this.state.tables[proposal].goalValue = 4
            this.state.tables[active].goalValue =10
            this.state.tables[negotiation].goalValue = 5
            this.state.tables[closedYTD].goalValue = 12
        }
        this.setState({tables: {...this.state.tables}});
    }

    componentDidMount() {
        const id = this.props.location && this.props.location.state && this.props.location.state.id ? parseInt(this.props.location.state.id) :
            (this.props.id ? this.props.id : parseInt(this.props.params.id));
        const emailId = this.props.location && this.props.location.state && this.props.location.state.id ? this.props.userData.email :
        (this.props.id ? this.props.id : this.props.userData.email);
        const contactId = this.props.location && this.props.location.state && this.props.location.state.contactId ? parseInt(this.props.location.state.contactId) :
            (this.props.id ? this.props.id : parseInt(this.props.params.contactId));
        if (id) {
            this.fetch(id,emailId,contactId);
            return;
        }
        this.setState({loading: false});
    }
}